import { render, staticRenderFns } from "./VulnerabilityDetailsModal.vue?vue&type=template&id=4ced57d8&scoped=true&"
import script from "./VulnerabilityDetailsModal.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=0&id=4ced57d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced57d8",
  null
  
)

export default component.exports